import { useContext } from 'react';
import { Localization } from '../../config/localization/localization';
import { LanguageSelectorContext } from '../../context/LanguageSelectorContext';
import { Input } from '../inputs';
import clsx from 'clsx';

export const SupervisorFields = () => {

    const { selectedLanguage } = useContext(LanguageSelectorContext);
    const localization = new Localization(selectedLanguage);

    return (
        <div className={'mt-4'}>
            <h1
                className={clsx(
                    'text-2xl font-semibold text-brand-500 dark:text-brand-100',
                    'min-w-[250px] border-b border-gray-200 pb-2 dark:border-gray-700'
                )}
            >
                {localization.translate('supervisor.header')}
            </h1>

            <div className={'flex h-full w-full flex-col items-center space-y-3 sm:mt-3'}>
                {/* FIRST NAME */}
                <Input
                    inputOptions={{
                        isRequired: true,
                        label: localization.translate('supervisor.firstName'),
                        name: 'techSupervisorFirstName',
                    }}
                    tooltip={localization.translate('supervisor.firstNameTooltip')}
                />

                {/* LAST NAME */}
                <Input
                    inputOptions={{
                        isRequired: true,
                        label: localization.translate('supervisor.lastName'),
                        name: 'techSupervisorLastName',
                    }}
                    tooltip={localization.translate('supervisor.lastNameTooltip')}
                />

                {/* PHONE NUMBER */}
                <Input
                    inputOptions={{
                        isRequired: true,
                        label: localization.translate('supervisor.phoneNumber'),
                        name: 'techSupervisorPhoneNumber',
                    }}
                    tooltip={localization.translate('supervisor.phoneNumberTooltip')}
                    type={'phone'}
                />

                {/* EMAIL ADDRESS */}
                <Input
                    inputOptions={{
                        isRequired: true,
                        label: localization.translate('supervisor.emailAddress'),
                        name: 'techSupervisorEmailAddress',
                    }}
                    tooltip={localization.translate('supervisor.emailAddressTooltip')}
                />
            </div>
        </div>
    );
};
